import { CSSProperties , useContext} from "react"
import { IconHappy } from '../img'
import { DataContext } from "../data/DataContext"

const StepFinishAge = () => {
    const { vidaCR, changeHandler2 } = useContext(DataContext);

    const centerCss: CSSProperties = {
        display: 'flex',
        justifyContent: 'center'
    }
    const finish = (e: any) => {
        e.preventDefault();
        vidaCR.finish();
    }
    return <>
        <div className="lbl-input-vida-cr mb-20">
            Muchas gracias por confiar en Seguros LAFISE, la <br /> aseguradora digital regional.
        </div>
        <div className="lbl-input-vida-cr card-vida-cr-finish" >
            <div className="mt-50 mb-30" style={centerCss}>
                <IconHappy />
            </div>
            <p className="mb-50">
                Nuestros ejecutivos se contactarán contigo <br /> para confirmar datos y coordinar la entrega <br /> de los documentos del seguro
            </p>
        </div>
        <div className="mt-30 mb-30" style={centerCss} >
            <button className='btn-vida-cr next' onClick={finish}>Finalizar</button>
        </div>
    </>
}

export { StepFinishAge }